<template>
  <div id="app" style="min-width:1200px">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>
